import { createAction } from '@reduxjs/toolkit';

export const analyticsHeaderOnClick = createAction('ANALYTICS::HEADER::CLICK');
